import Index from '@/pages/Index'
import Products from '@/pages/Products'
import News from '@/pages/News'
import NewsDetail from '@/pages/NewsDetail'
import About from '@/pages/About'
// import Layout from '@/pages/components/Layout'

const routes = [
  {
    name: 'index',
    path: '/:lang?/',
    component: Index,
    exact: true,
    strict: true
  },
  {
    name: 'news',
    path: '/:lang?/news',
    component: News,
    exact: true
  },
  {
    name: 'newsDetail',
    path: '/:lang?/news/:id',
    component: NewsDetail,
    exact: true
  },
  {
    name: 'products',
    path: '/:lang?/products',
    component: Products,
    exact: true
  },
  {
    name: 'about',
    path: '/:lang?/about',
    component: About,
    exact: true
  },
  
  
  // {
  //     path: "/list/:id",
  //     component: Detail,
  //     exact: true //是否为严格模式
  // },
]

export default routes
